import React from 'react'
import { Button, Modal, Header } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import AnimatedButton from './AnimatedButton'
import { useTranslation } from 'react-i18next'

const CustomModal = ({
	triggerButton,
	headerTitle,
	content,
	onAccept,
	onCancel,
	open,
	setOpen,
}) => {
	const { t } = useTranslation()

	return (
		<React.Fragment>
			<Modal open={open} size='small' trigger={triggerButton}>
				<Header>
					<Modal.Header>{headerTitle}</Modal.Header>
					<Modal.Content>
						<Header.Subheader>{content}</Header.Subheader>
					</Modal.Content>
				</Header>
				<Modal.Actions>
					<AnimatedButton
						bordered={true}
						animated={false}
						title={t("Cancelar")}
						iconname="cancel"
						type="button"
						color="teal"
						onClick={(e) => {
							setOpen(!open)
						}}
					/>
					<AnimatedButton
						bordered={true}
						content={t("Aceptar")}
						iconname="check"
						type="button"
						onClick={(e) => {
							setOpen(!open)
							onAccept(e)
						}}
					/>
				</Modal.Actions>
			</Modal>
		</React.Fragment>
	)
}

CustomModal.propTypes = {
	triggerButton: PropTypes.object,
	headerTitle: PropTypes.string,
	content: PropTypes.string,
	onAccept: PropTypes.func,
	onCancel: PropTypes.func,
	open: PropTypes.bool,
	setOpen: PropTypes.func,
}

export default CustomModal
